export const Pedido = `
mutation ($payload: ipedido) {
  _CreatePedido (payload: $payload) {
    id,
    status,
    paymentid,
    usuario {
      id,
      nome,
      sobrenome,
      usuario,
      email,
      status
    },
    dateCreate,
    itens {
      id,
      code,
      tipo,
      name,
      status,
      preco,
      oferta,
      img {
        id,
        img
      },
      descricao,
      dateOfertaStart,
      dateOfertaEnd,
      categoria,
      gerEstoque,
      statusEstoque,
      estoque,
      pendencia,
      visibilidade,
      visualizacao,
      atributos {
        active,
        id,
        name,
        values {
          active,
          id,
          name,
          selected
        }
      },
      estoqueVariavel {
        id,
        src {
          quantidade,
          values {
            id,
            idParent,
            name,
            value
          }
        }
      },
      dateCreate,
      caracter {
        id,
        name,
        icon
      },
      qtda
    },
    gift,
    giftvalor,
    frete,
    valorTotal
  }
}
`
export const clientLogin = `
query ($payload: clientLogin) {
  GetClientLogin(payload: $payload) {
    usuario {
      id,
      _id,
      nome,
      sobrenome,
      usuario,
      email,
      tipo,
      status,
      logincount,
      token
    },
    endereco {
      id,
      _id,
      cpf,
      celular,
      cep,
      endereco,
      bairro,
      numero,
      cidade,
      uf
    }
  }
}
`
export const pedidos = `
query ($payload: Int) {
  GetPedidoClient (payload: $payload) {
    pedido {
      id,
      status,
      usuario {
        id,
        nome,
        sobrenome,
        usuario,
        email,
        status
      },
      dateCreate,
      itens {
        id,
        code,
        img {
          id,
          img
        },
        name,
        status,
        preco,
        oferta,
        qtda,
        pedidoitematributos {
          name,
          value
        }
      },
      gift,
      giftvalor,
      frete,
      notas
    },
    endereco {
      id,
      cpf,
      celular,
      cep,
      endereco,
      bairro,
      numero,
      cidade,
      uf
    }
  }
}
`